<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y transition="scale-transition" :nudge-width="300">
    <template v-slot:activator="{ on }">
      <v-btn
        color="indigo"
        dark
        small
        v-on="on"
      >
        <v-icon left>{{ filterIcon }}</v-icon>
        <span>{{ $vuetify.lang.t('$vuetify.map.tableFilter.date') }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-card-subtitle>{{ header }}</v-card-subtitle>
        <v-spacer></v-spacer>
        <v-btn icon @click="clearData">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">{{ filterRemoveIcon }}</v-icon>
            </template>
            <span>{{ $vuetify.lang.t('$vuetify.map.tableFilter.clear') }}</span>
          </v-tooltip>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <span class="caption">{{ $vuetify.lang.t('$vuetify.map.managerMap.filterHeaders.lowerBound') }}</span>
        <v-row no-gutters>
          <v-col>
            <date-filter :value="start.date" :max="max" :min="min" type="start" @date-filter-changed="changeDate"></date-filter>
          </v-col>
          <v-col>
            <time-filter type="start" ref="startTimeFilter" :disabled="!start.date"
                         @time-filter-changed="changeTime"></time-filter>
          </v-col>
        </v-row>
        <span class="caption">{{ $vuetify.lang.t('$vuetify.map.managerMap.filterHeaders.upperBound') }}</span>
        <v-row no-gutters>
          <v-col>
            <date-filter :value="finish.date" :max="max" :min="min" type="finish" @date-filter-changed="changeDate"></date-filter>
          </v-col>
          <v-col>
            <time-filter type="finish" ref="finishTimeFilter" :disabled="!finish.date"
                         @time-filter-changed="changeTime"></time-filter>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mdiFilter, mdiFilterRemove } from '@mdi/js'
import DateFilter from './utils/dateFilter'
import TimeFilter from './utils/timeFilter'
import { defaultDatetimeFilterState } from '../../../utils/filters'

export default {
  name: 'datetimeFilter',
  components: { TimeFilter, DateFilter },
  props: {
    column: String,
    header: String,
    min: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: ''
    },
    startDate: {
      type: String,
      default: ''
    },
    finishDate: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      menu: false,

      start: defaultDatetimeFilterState(this.startDate),
      finish: defaultDatetimeFilterState(this.finishDate),

      filterIcon: mdiFilter,
      filterRemoveIcon: mdiFilterRemove
    }
  },
  // data: () => ({
  //   menu: false,
  //
  //   start: defaultDatetimeFilterState(),
  //   finish: defaultDatetimeFilterState(),
  //
  //   filterIcon: mdiFilter,
  //   filterRemoveIcon: mdiFilterRemove
  // }),
  methods: {
    clearData (emit = true) {
      const states = ['start', 'finish']
      for (const state of states) {
        this[state] = defaultDatetimeFilterState()
        if (this.$refs.hasOwnProperty(`${state}TimeFilter`)) {
          this.$refs[`${state}TimeFilter`].clearState()
        }
      }

      if (emit) {
        this.$emit('datetime-cleared', { 'column': this.column })
      }
    },
    changeDate (data) {
      this[data.type].date = data.value
      this.$emit('datetime-changed', { ...data, mode: 'date', 'column': this.column })
    },
    changeTime (data) {
      this[data.type].time = data.value
      this.$emit('datetime-changed', { ...data, mode: 'time', 'column': this.column })
    }
  }
}
</script>

<style scoped>

</style>
